module.exports = __webpack_public_path__ + "static/img/login-bg-admin.2a07a25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/login-bg-admin.jpg
// module id = YdcQ
// module chunks = 1